<!--
<vue-pagination
  @paginate="yourPaginationMethod"
  :data="yourPaginationData">
</vue-pagination>
-->

<template>
  <nav aria-label="Pagination" v-if="data.pages > 1">
    <ul class="uk-pagination">
      <li>
        <a v-if="isCurrent(1)">
          <span uk-pagination-previous></span>
        </a>

        <a href="#" @click="goToPage(--data.current)" v-else>
          <span uk-pagination-previous></span>
        </a>
      </li>

      <li
      :class="{ 'uk-active': isCurrent(page), 'uk-disabled': page == '...'}"
      :key="i"
      v-for="(page, i) in getPages()">
        <span v-if="isCurrent(page) || page == '...'">
          {{ page }}
        </span>

        <a
        href="#"
        @click="goToPage(page)"
        v-else>{{ page }}</a>
      </li>

      <li>
        <a v-if="isCurrent(data.pages)">
          <span uk-pagination-next></span>
        </a>

        <a href="#" @click="goToPage(++data.current)" v-else>
          <span uk-pagination-next></span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
  export default {
    props: {
      data: {
  			type: Object,
  			default: function() {
  				return {
  					current: 1,
  					pages: 0
  				}
  			}
  		}
    },
    methods: {
      goToPage: function(page) {
        if (page === '...') {
  				return;
  			}

        this.$emit('paginate', parseInt(page));
      },

      isCurrent(page) {
        return parseInt(this.data.current) == parseInt(page);
      },

      getPages: function() {
  			var current = this.data.current,
  				last  = this.data.pages,
  				delta = 1,
  				left  = current - delta,
  				right = current + delta + 1,
  				range = [],
  				pages = [],
  				l;

  			for (var i = 1; i <= last; i++) {
  				if (i == 1 || i == last || (i >= left && i < right)) {
  					range.push(i);
  				}
  			}

  			range.forEach(function (i) {
  				if (l) {
  					if (i - l === 2) {
  						pages.push(l + 1);
  					} else if (i - l !== 1) {
  						pages.push('...');
  					}
  				}
  				pages.push(i);
  				l = i;
  			});

  			return pages;
  		}
    },
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/VuePagination.vue